import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';

export interface ChartTitleProps {
  title: string;
  subtitle?: string;
}

export const ChartTitle: React.FC<ChartTitleProps> = ({ title, subtitle }) => {
  const theme = useTheme();

  return (
    <Flex flexDirection='column'>
      <Text variant='h6' fontWeight='fontWeightSemiBold'>
        {title}
      </Text>
      <Text
        variant='bodyBig'
        fontWeight='fontWeightMedium'
        sx={{ color: theme.palette.grey.A100 }}
      >
        {subtitle}
      </Text>
    </Flex>
  );
};
